module.exports = __webpack_public_path__ + "img/17.374b12bb.jpg";